export default __webpack_public_path__ + "static/media/flags.f520837f.png";